<template>
  <div class="oauth-container">
    <v-progress-circular
      indeterminate
      size="120"
      width="16"
      color="primary"
    />
    <h1>{{$t('Iniciando sesión')}}...</h1>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  data () {
    return {
      code: this.$route.query.code,
      loading: true,
      email: ''
    }
  },
  async mounted () {
    try {
      if (this.$route.query.error) {
        return this.$router.push({ name: 'Login' })
      }

      const source = localStorage.getItem('source')
      const medium = localStorage.getItem('medium')
      const campaign = localStorage.getItem('campaign')
      const content = localStorage.getItem('content')

      const response = await firebase.functions().httpsCallable('authenticateWithLinkedIn')({
        code: this.code,
        utm_params: {
          source,
          medium,
          campaign,
          content
        }
      })

      const { email, password } = response.data
      this.email = email

      await firebase.auth().signInWithEmailAndPassword(email, password)
    } catch (error) {
      this.email = `error: ${error.toString()}`
      console.error(error)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.oauth-container {
  margin: 2rem 3rem;
  height: 80vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    margin-top: 2rem;
    font-size: 1.75rem;
    font-weight: 600;
  }
}
</style>
